export const dispatchEventForPrint = (event: CustomEvent<string>) => {
    document.body.dispatchEvent(event);
};
